import axios from './financeiroApi';

const getPath = () => `/api/v1/backend/periodo-fechado`;

const fechamentoPeriodoApi = {
  criar: (params) => {
    const url = `${getPath()}`;
    return axios.post(url, params);
  },

  buscarUltimoPeriodo: (funcionalidade, data) => {
    const url = `${getPath()}/buscar-ultimo-periodo?funcionalidade=${funcionalidade}&data=${data}`;
    return axios.get(url);
  },

  atualizarNota: (id, periodo) => {
    const url = `${getPath()}/${id}`;
    return axios.put(url, periodo);
  },

  buscarHistorico: async (search) => {
    const url = `${getPath()}?page=${search.page}&size=${search.size}${search.query ? `&q=${search.query || ''}` : ''}${
      search.sort ? `&sort=${search.sort}` : '&sort=dataHora,DESC'
    }`;

    return axios.get(url, {
      headers: {
        'Content-Type': 'application/json; charset=utf8',
        Accept: 'application/json; charset=utf8',
      },
      responseType: 'json',
    });
  },
};

export { fechamentoPeriodoApi };
